/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Role {
    ORGANIZATION_MEMBER = 'OrganizationMember',
    ORGANIZATION_STAFF = 'OrganizationStaff',
    ORGANIZATION_ADMIN = 'OrganizationAdmin',
    SUPER_ADMIN = 'SuperAdmin',
}